import { type ReactNode, type Ref } from 'react'
import { RefreshCw, Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'
import type { PullToRefreshState } from '@/lib/hooks/usePullToRefresh'
import { INDICATOR_HEIGHT } from '@/lib/pullToRefresh/pullToRefreshConstants'

type Props = {
  state: PullToRefreshState
  contentRef: Ref<HTMLDivElement>
  indicatorRef: Ref<HTMLDivElement>
  iconWrapperRef: Ref<HTMLDivElement>
  children: ReactNode
}

export default function PullToRefreshIndicator({
  state,
  contentRef,
  indicatorRef,
  iconWrapperRef,
  children,
}: Props) {
  const isActive = state !== 'idle'

  return (
    <div className={cn('relative', isActive && 'overflow-hidden')}>
      <div
        ref={indicatorRef}
        className="absolute left-0 right-0 flex items-center justify-center"
        style={{ top: -INDICATOR_HEIGHT, height: INDICATOR_HEIGHT }}
      >
        {state === 'refreshing' ? (
          <Loader2 className="size-6 animate-spin text-muted-foreground" />
        ) : (
          <div ref={iconWrapperRef}>
            <RefreshCw
              className={cn(
                'size-6 transition-colors duration-150',
                state === 'triggered' ? 'text-foreground' : 'text-muted-foreground',
              )}
            />
          </div>
        )}
      </div>

      <div ref={contentRef}>{children}</div>
    </div>
  )
}
